import React from 'react';
import PropTypes from 'prop-types';
import { getRoomCountText } from './helpers';

const RoomCountText = (props) => {
	const { rooms } = props;

	if (rooms.length === 0) {
		return null;
	}

	return <>{getRoomCountText(rooms)}</>;
};

RoomCountText.propTypes = {
	rooms: PropTypes.arrayOf(
		PropTypes.shape({ type: PropTypes.number.isRequired }),
	),
};

RoomCountText.defaultProps = {
	rooms: [],
};

export default RoomCountText;
